// ========================================
// SCHALTER: Navigation Pfeile Ein/Aus
// ========================================
const ENABLE_NAVIGATION_ARROWS = false; // true = an, false = aus
// ========================================

document.addEventListener("DOMContentLoaded", () => {
  if (document.querySelector(".cd-beer-design")) return;
  const fixedLivePreview = () => {
    const galleryWrapperSelector = ".grid__item.product__media-wrapper";
    const $gallery = document.querySelector(galleryWrapperSelector);
    const $form = document.getElementById("tee-artwork-form");

    if (!$gallery || !$form) return;

    const style = document.createElement("style");
    style.innerHTML = `
      .gallery--sticky:not(.gallery--sticky--hide) ${galleryWrapperSelector} {
        height: auto !important;
      }

      .gallery--sticky:not(.gallery--sticky--hide) ${galleryWrapperSelector} .tee-gallery-content {
        background: #fff;
        box-shadow: 0 2px 5px 3px rgba(0, 0, 0, .15);
        display: flex;
        justify-content: center;
        align-items: flex-start;
        left: 0;
        position: fixed;
        top: 0;
        width: 100vw;
        z-index: 99;
        transition: opacity 0.3s ease, transform 0.3s ease, height 0.2s ease;
        opacity: 1;
        transform: translateY(0);
        padding: 0;
        overflow: hidden;
      }

      .gallery--sticky.gallery--sticky--hide ${galleryWrapperSelector} .tee-gallery-content {
        opacity: 0;
        transform: translateY(-10px);
        pointer-events: none;
      }

      .gallery--sticky:not(.gallery--sticky--hide) ${galleryWrapperSelector} .tee-gallery {
        width: auto;
        transform: scale(.7);
        transform-origin: center top;
        margin: 0;
        height: auto;
      }

      .gallery--sticky:not(.gallery--sticky--hide) ${galleryWrapperSelector} .tee-thumbnails,
      .gallery--sticky:not(.gallery--sticky--hide) ${galleryWrapperSelector} .tee-slider__dots {
        display: none;
      }

      .gallery--sticky .gallery--close-button {
        display: block;
      }

      ${ENABLE_NAVIGATION_ARROWS ? `
      .gallery--sticky .gallery-nav-arrow {
        display: flex;
      }

      .gallery-nav-arrow {
        display: none;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        background: rgba(0, 0, 0, 0.5);
        color: #fff;
        width: 40px;
        height: 40px;
        border-radius: 50%;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        z-index: 100;
        transition: background 0.3s ease;
        font-size: 20px;
        font-weight: bold;
        user-select: none;
      }

      .gallery-nav-arrow:hover {
        background: rgba(0, 0, 0, 0.8);
      }

      .gallery-nav-arrow.prev {
        left: 10px;
      }

      .gallery-nav-arrow.next {
        right: 10px;
      }
      ` : ''}

      .sticky-gallery-button {
        background-color: #000;
        color: #fff;
        font-size: 12px;
        padding: 10px 12px;
        border-radius: 20px;
        box-shadow: 0px 0px 5px rgba(0,0,0,0.2);
        display: none;
        height: auto;
        position: fixed;
        right: 16px;
        top: 100px;
        z-index: 999;
        cursor: pointer;
        font-family: sans-serif;
      }

      .gallery--close-button {
        background-image: url('data:image/svg+xml;utf8,<svg height="329pt" viewBox="0 0 329.26933 329" width="329pt" xmlns="http://www.w3.org/2000/svg"><path d="M194.8 164.77l128.21-128.21c8.34-8.34 8.34-21.82 0-30.16-8.34-8.34-21.82-8.34-30.16 0l-128.21 128.21-128.21-128.21c-8.34-8.34-21.82-8.34-30.16 0-8.34 8.34-8.34 21.82 0 30.16l128.21 128.21-128.21 128.21c-8.34 8.34-8.34 21.82 0 30.16 4.16 4.16 9.62 6.25 15.08 6.25s10.92-2.09 15.08-6.25l128.21-128.21 128.21 128.21c4.16 4.16 9.62 6.25 15.08 6.25s10.92-2.09 15.08-6.25c8.34-8.34 8.34-21.82 0-30.16z"/></svg>');
        background-position: center;
        background-repeat: no-repeat;
        background-size: 16px 16px;
        height: 16px;
        opacity: 0.5;
        position: absolute;
        right: 20px;
        top: 20px;
        width: 16px;
        cursor: pointer;
      }
    `;
    document.head.appendChild(style);

    let stickyButton;
    let hasStickyButton = false;
    let hasCloseButton = false;
    let hasNavArrows = false;
    let resizeObserver = null;
    let mutationObserver = null;
    let updateTimeout = null;
    let currentSlideIndex = 0;

    const updateGalleryHeight = () => {
      if (updateTimeout) {
        clearTimeout(updateTimeout);
      }

      const teeGallery = document.querySelector(`${galleryWrapperSelector} .tee-gallery`);
      const teeGalleryContent = document.querySelector(`${galleryWrapperSelector} .tee-gallery-content`);
      
      if (teeGallery && teeGalleryContent && document.body.classList.contains("gallery--sticky")) {
        requestAnimationFrame(() => {
          const actualHeight = teeGallery.offsetHeight * 0.7;
          teeGalleryContent.style.height = `${actualHeight}px`;
        });
      }
    };

    const navigateGallery = (direction) => {
      console.log('Navigate:', direction);
      
      // Methode 1: Thumbnails finden und klicken
      const thumbnails = document.querySelectorAll(`${galleryWrapperSelector} .tee-thumbnails button, ${galleryWrapperSelector} .tee-thumbnails .tee-thumbnail`);
      if (thumbnails.length > 0) {
        console.log('Found thumbnails:', thumbnails.length);
        if (direction === 'next') {
          currentSlideIndex = (currentSlideIndex + 1) % thumbnails.length;
        } else {
          currentSlideIndex = (currentSlideIndex - 1 + thumbnails.length) % thumbnails.length;
        }
        thumbnails[currentSlideIndex].click();
        setTimeout(updateGalleryHeight, 200);
        return;
      }

      // Methode 2: Dots finden und klicken
      const dots = document.querySelectorAll(`${galleryWrapperSelector} .tee-slider__dot`);
      if (dots.length > 0) {
        console.log('Found dots:', dots.length);
        if (direction === 'next') {
          currentSlideIndex = (currentSlideIndex + 1) % dots.length;
        } else {
          currentSlideIndex = (currentSlideIndex - 1 + dots.length) % dots.length;
        }
        dots[currentSlideIndex].click();
        setTimeout(updateGalleryHeight, 200);
        return;
      }

      // Methode 3: Slider Container scrollen
      const sliderContainer = document.querySelector(`${galleryWrapperSelector} .tee-slider__slides, ${galleryWrapperSelector} .tee-slider`);
      if (sliderContainer) {
        console.log('Found slider container');
        const slideWidth = sliderContainer.offsetWidth;
        const currentScroll = sliderContainer.scrollLeft;
        const newScroll = direction === 'next' 
          ? currentScroll + slideWidth 
          : currentScroll - slideWidth;
        
        sliderContainer.scrollTo({
          left: newScroll,
          behavior: 'smooth'
        });
        setTimeout(updateGalleryHeight, 200);
        return;
      }

      // Methode 4: Alle Slides finden
      const slides = document.querySelectorAll(`${galleryWrapperSelector} .tee-slider__slide, ${galleryWrapperSelector} .slide`);
      if (slides.length > 0) {
        console.log('Found slides:', slides.length);
        if (direction === 'next') {
          currentSlideIndex = (currentSlideIndex + 1) % slides.length;
        } else {
          currentSlideIndex = (currentSlideIndex - 1 + slides.length) % slides.length;
        }
        slides[currentSlideIndex].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        setTimeout(updateGalleryHeight, 200);
        return;
      }

      console.log('No navigation method found');
    };

    const createNavigationArrows = () => {
      if (!ENABLE_NAVIGATION_ARROWS) return; // Schalter prüfen

      const prevArrow = document.createElement("div");
      prevArrow.className = "gallery-nav-arrow prev";
      prevArrow.innerHTML = "‹";
      prevArrow.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        navigateGallery('prev');
      });

      const nextArrow = document.createElement("div");
      nextArrow.className = "gallery-nav-arrow next";
      nextArrow.innerHTML = "›";
      nextArrow.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        navigateGallery('next');
      });

      const teeGalleryContent = document.querySelector(`${galleryWrapperSelector} .tee-gallery-content`);
      if (teeGalleryContent) {
        teeGalleryContent.appendChild(prevArrow);
        teeGalleryContent.appendChild(nextArrow);
        hasNavArrows = true;
      }
    };

    const createStickyButton = () => {
      stickyButton = document.createElement("div");
      stickyButton.className = "sticky-gallery-button";
      stickyButton.textContent = "Live Vorschau anzeigen";

      stickyButton.addEventListener("click", (e) => {
        e.preventDefault();
        document.body.classList.add("gallery--sticky");
        document.body.classList.remove("gallery--sticky--hide");
        
        updateGalleryHeight();

        const teeGallery = document.querySelector(`${galleryWrapperSelector} .tee-gallery`);
        if (teeGallery && !resizeObserver) {
          resizeObserver = new ResizeObserver(() => {
            updateGalleryHeight();
          });
          resizeObserver.observe(teeGallery);
        }

        if (teeGallery && !mutationObserver) {
          mutationObserver = new MutationObserver(() => {
            updateGalleryHeight();
          });
          mutationObserver.observe(teeGallery, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: ['class', 'style']
          });
        }

        const gallerySlider = document.querySelector(`${galleryWrapperSelector} .tee-gallery`);
        if (gallerySlider) {
          gallerySlider.addEventListener('touchstart', updateGalleryHeight);
          gallerySlider.addEventListener('touchmove', updateGalleryHeight);
          gallerySlider.addEventListener('touchend', updateGalleryHeight);
          gallerySlider.addEventListener('click', updateGalleryHeight);
        }
        
        stickyButton.style.display = "none";
      });

      document.body.appendChild(stickyButton);
      hasStickyButton = true;
    };

    const createCloseButton = () => {
      const closeButton = document.createElement("div");
      closeButton.className = "gallery--close-button";
      closeButton.addEventListener("click", (e) => {
        e.preventDefault();
        document.body.classList.remove("gallery--sticky");
        document.body.classList.add("gallery--sticky--hide");
        
        if (resizeObserver) {
          resizeObserver.disconnect();
          resizeObserver = null;
        }
        if (mutationObserver) {
          mutationObserver.disconnect();
          mutationObserver = null;
        }

        const teeGalleryContent = document.querySelector(`${galleryWrapperSelector} .tee-gallery-content`);
        if (teeGalleryContent) {
          teeGalleryContent.style.removeProperty("height");
        }

        const formRect = $form.getBoundingClientRect();
        const isFormVisible = formRect.top < window.innerHeight && formRect.bottom > 0;

        if (isFormVisible) {
          stickyButton.style.display = "block";
        }
      });

      const $teeGallery = document.querySelector(`${galleryWrapperSelector} #tee-gallery`);
      if ($teeGallery) {
        $teeGallery.appendChild(closeButton);
        hasCloseButton = true;
      }
    };

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!document.body.classList.contains("gallery--sticky")) {
            stickyButton.style.display = entry.isIntersecting ? "block" : "none";
          }
        });
      },
      { threshold: 0.3 }
    );

    if (!hasStickyButton) {
      createStickyButton();
    }

    if (!hasCloseButton) {
      createCloseButton();
    }

    if (!hasNavArrows) {
      createNavigationArrows();
    }

    observer.observe($form);
  };

  const w = window.innerWidth;
  const h = window.innerHeight;
  if (h / w > 1.5 && w < 768) {
    setTimeout(() => {
      fixedLivePreview();
    }, 1000);
  }
});
/* Demo product layout: independent live view; never resize or relocate the app gallery. */
(() => {
  const init = () => {
    if (!document.querySelector(".cd-beer-design") || document.getElementById("cd-live-toggle")) return;
    const mobile = window.matchMedia("(max-width: 749px)");
    const toggle = document.createElement("button");
    toggle.type = "button";
    toggle.id = "cd-live-toggle";
    toggle.textContent = "Live Vorschau anzeigen";
    toggle.setAttribute("aria-expanded", "false");
    toggle.setAttribute("aria-controls", "cd-live-preview");
    const launcher = document.createElement("div");
    launcher.id = "cd-live-launcher";
    const dismiss = document.createElement("button");
    dismiss.id = "cd-live-dismiss";
    dismiss.type = "button";
    dismiss.textContent = "×";
    dismiss.setAttribute("aria-label", "Vorschau-Button am Rand einklappen");
    const dock = document.createElement("button");
    dock.id = "cd-live-dock";
    dock.type = "button";
    dock.textContent = "‹";
    dock.setAttribute("aria-label", "Live-Vorschau-Button wieder einblenden");
    launcher.append(toggle, dismiss, dock);
    const panel = document.createElement("aside");
    panel.id = "cd-live-preview";
    panel.hidden = true;
    panel.setAttribute("aria-label", "Live Vorschau deiner Gestaltung");
    const viewport = document.createElement("div");
    viewport.className = "cd-live-viewport";
    viewport.setAttribute("aria-hidden", "true");
    const close = document.createElement("button");
    close.type = "button";
    close.className = "cd-live-close";
    close.setAttribute("aria-label", "Live Vorschau schließen");
    close.textContent = "×";
    panel.append(viewport, close);
    const style = document.createElement("style");
    style.textContent = `
      #cd-live-toggle {position:fixed;right:16px;top:100px;z-index:45;border:0;border-radius:22px;background:#2f2f2f;color:#fff;font-family:inherit;font-size:12px;font-weight:600;line-height:1.3;padding:12px 15px;box-shadow:0 2px 8px #0002;cursor:pointer;display:none}
      #cd-live-preview {position:fixed;inset:0 0 auto;z-index:45;background:#fff;box-shadow:0 3px 14px #0002;padding:0;box-sizing:border-box}
      #cd-live-preview[hidden] {display:none!important}
      .cd-live-viewport {position:relative;margin:auto;overflow:hidden;pointer-events:none}
      .cd-live-viewport>.tee-mockup {position:absolute!important;top:0;left:0;transform-origin:top left;pointer-events:none}
      #cd-live-preview .cd-live-close {position:absolute!important;top:max(10px, env(safe-area-inset-top))!important;right:10px!important;z-index:100!important;width:40px!important;height:40px!important;min-width:40px;min-height:40px;display:grid!important;place-items:center;padding:0!important;border:1px solid #e3d5ca!important;border-radius:50%!important;background:#fff!important;color:#2a160c!important;box-shadow:0 2px 10px #0003;font-size:30px!important;line-height:1!important;opacity:1!important;visibility:visible!important;cursor:pointer;pointer-events:auto!important}
      #cd-live-launcher {position:fixed;right:16px;top:100px;z-index:45;display:none;align-items:center;background:#2f2f2f;border-radius:24px;box-shadow:0 2px 8px #0002}
      #cd-live-launcher #cd-live-toggle {position:static;box-shadow:none;padding:12px 6px 12px 15px}
      #cd-live-dismiss,#cd-live-dock {border:0;color:#fff;background:transparent;font-family:inherit;cursor:pointer;box-sizing:border-box}
      #cd-live-dismiss {width:36px;height:40px;font-size:23px;padding:0 5px 0 0;line-height:1;display:grid;place-items:center}
      #cd-live-dock {width:24px;height:44px;padding:0;font-size:28px;line-height:1;display:grid;place-items:center}
      #cd-live-launcher button[hidden] {display:none!important}
      #cd-live-launcher.is-parked {right:0;border-radius:10px 0 0 10px}
      @media(min-width:750px){#cd-live-preview,#cd-live-toggle,#cd-live-launcher{display:none!important}}
    `;
    document.head.append(style);
    document.body.append(launcher, panel);
    let parked = false;
    let open = false;
    let timer = null;
    let root = null;
    let gallery = null;
    const draw = () => {
      if (!open || panel.hidden) return;
      const source = gallery?.querySelector(".tee-slide--active .tee-hover-zoom-normal .tee-mockup")
        || gallery?.querySelector(".tee-slide--active .tee-mockup")
        || gallery?.querySelector(".tee-mockup");
      if (!source) { viewport.replaceChildren(); return; }
      const width = source.offsetWidth;
      const height = source.offsetHeight;
      if (!width || !height) return;
      const scale = window.innerWidth / width;
      const copy = source.cloneNode(true);
      // Prefix local SVG definitions, while keeping references to Teeinblue's live artwork.
      const ids = new Map();
      copy.querySelectorAll("[id]").forEach(el => {
        const old = el.id;
        const next = "cd-live-" + old;
        ids.set(old, next);
        el.id = next;
      });
      if (copy.id) copy.removeAttribute("id");
      copy.querySelectorAll("*").forEach(el => {
        for (const attr of Array.from(el.attributes)) {
          let value = attr.value;
          ids.forEach((next, old) => {
            if (value === "#" + old) value = "#" + next;
            value = value.split("url(#" + old + ")").join("url(#" + next + ")");
          });
          if (value !== attr.value) el.setAttribute(attr.name, value);
        }
      });
      copy.style.transform = "scale(" + scale + ")";
      copy.style.width = width + "px";
      copy.style.height = height + "px";
      viewport.style.width = width * scale + "px";
      viewport.style.height = height * scale + "px";
      viewport.replaceChildren(copy);
    };
    const schedule = () => {
      if (!open || timer !== null) return;
      timer = setTimeout(() => { timer = null; sync(); draw(); }, 80);
    };
    const setOpen = (value) => {
      open = value;
      toggle.setAttribute("aria-expanded", String(value));
      sync();
      if (value) draw();
    };
    const sync = () => {
      const form = document.getElementById("tee-artwork-form");
      gallery = document.querySelector(".product__media-wrapper .tee-gallery");
      const rect = form?.getBoundingClientRect();
      const active = mobile.matches && gallery && rect && rect.top < window.innerHeight && rect.bottom > 0;
      launcher.style.display = active && !open ? "flex" : "none";
      launcher.classList.toggle("is-parked", parked);
      toggle.style.display = active && !open && !parked ? "block" : "none";
      dismiss.hidden = parked;
      dock.hidden = !parked;
      panel.hidden = !(active && open);
      if (!active && open) {
        open = false;
        toggle.setAttribute("aria-expanded", "false");
      }
    };
    const observer = new MutationObserver(() => { sync(); schedule(); });
    const bind = () => {
      const next = document.querySelector("product-info") || document.querySelector(".product");
      if (next && next !== root) {
        observer.disconnect();
        root = next;
        observer.observe(root, {subtree:true,childList:true,attributes:true,characterData:true});
      }
      sync();
      schedule();
    };
    dismiss.addEventListener("click", () => {parked = true; sync(); dock.focus({preventScroll:true});});
    dock.addEventListener("click", () => {parked = false; sync(); toggle.focus({preventScroll:true});});
    toggle.addEventListener("click", () => { setOpen(true); close.focus({preventScroll:true}); });
    close.addEventListener("click", () => { setOpen(false); if (toggle.style.display !== "none") toggle.focus({preventScroll:true}); });
    document.addEventListener("keydown", e => { if (e.key === "Escape" && open) {setOpen(false);toggle.focus({preventScroll:true});} });
    document.addEventListener("teeinblue-event-component-injected", bind);
    window.addEventListener("scroll", sync, {passive:true});
    window.addEventListener("resize", () => {sync();schedule();}, {passive:true});
    document.addEventListener("visibilitychange", () => {if(document.hidden)setOpen(false);});
    bind();
    // App injection can finish after DOMContentLoaded.
    setTimeout(bind, 1500);
  };
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init, {once:true});
  else init();
})();
